import { questionData } from '../assets/data/mission2/question';
import Debrief from '../components/Debrief';
import InputNumber from '../components/InputNumber';
import MainButton from '../components/MainButton';
import MissionHeader from '../components/MissionHeader';
import '../styles/Question.css';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function Question() {
    const [value, setValue] = useState<number>(0);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [isCorrect, setIsCorrect] = useState<boolean>(true);
    const [isCheckingAnswer, setIsCheckingAnswer] = useState<boolean>(false);
    const navigate = useNavigate();
    const { missionNumber } = useParams<{ missionNumber: string }>();

    const currentQuestion = questionData[currentQuestionIndex];
    const totalQuestions = Object.keys(questionData).length;
    const isLastQuestion = currentQuestionIndex === totalQuestions - 1;

    const onEnterPress = () => {
        setIsCheckingAnswer(true);
        const goodAnswer = questionData[currentQuestionIndex].answer;
        if (value === goodAnswer) {
            // alert('Bonne réponse ! ' + questionData[currentQuestionIndex].feedback);
            setIsCorrect(true);
        } else {
            // alert('Mauvaise réponse. ' + questionData[currentQuestionIndex].feedback);
            setIsCorrect(false);
        }
    };

    const handleNextQuestion = () => {
        if (!isCorrect) {
            setIsCheckingAnswer(false);
            setValue(0);
            return;
        }

        if (!isLastQuestion) {
            setCurrentQuestionIndex((prev) => prev + 1);
            setIsCheckingAnswer(false);
            setValue(0);
            return;
        }

        navigate(`/mission/${missionNumber}/game`);
    };

    if (!currentQuestion) {
        return (
            <div>
                <h1>Question</h1>
                <p>Aucune question disponible pour cette carte.</p>
            </div>
        );
    }
    return (
        <div className='questionPage-container'>
            <div className='questionPage-content'>
                {!isCheckingAnswer && (
                    <>
                        <MissionHeader
                            showBackButton={false}
                            showSettingsButton={false}
                            showCloseButton={true}
                            closeButtonVariant='tertiary'
                        />
                        <h3
                            className='questionPage-text'
                            dangerouslySetInnerHTML={{
                                __html: currentQuestion.question.replace(/\n/g, '<br />'),
                            }}
                        ></h3>
                        <div className='questionPage-input'>
                            <InputNumber
                                setValue={setValue}
                                tensInitialValue={0}
                                onesInitialValue={0}
                                onEnter={onEnterPress}
                            />
                            <p className='questionPage-mois'>mois</p>
                        </div>
                        <img
                            src='./images/agent-image-2.png'
                            alt='Image agent'
                            className='questionPage-image'
                        />
                        <div className='questionPage-button'>
                            <MainButton
                                text='Valider'
                                onClick={onEnterPress}
                            />
                        </div>
                    </>
                )}
                {isCheckingAnswer && !isCorrect && (
                    <Debrief
                        isCorrectAnswer={false}
                        handleButtonClick={handleNextQuestion}
                    />
                )}
                {isCheckingAnswer && isCorrect && !isLastQuestion && (
                    <Debrief
                        isCorrectAnswer={true}
                        textDebrief={currentQuestion.feedback}
                        illustrationDebrief='histoire-2/bebe-quiz'
                        handleButtonClick={handleNextQuestion}
                    />
                )}
                {isCheckingAnswer && isCorrect && isLastQuestion && (
                    <div className='questionPage-feedback-container'>
                        <MissionHeader
                            showBackButton={false}
                            showSettingsButton={false}
                            showCloseButton={true}
                            closeButtonVariant='tertiary'
                        />
                        <p
                            className='questionPage-text questionPage-feedback-text'
                            dangerouslySetInnerHTML={{
                                __html: currentQuestion.feedback?.replace(/\n/g, '<br />') ?? '',
                            }}
                        ></p>
                        <img
                            src='./images/agent-image-5.png'
                            alt='Image agent'
                            className='questionPage-feedback-image'
                        />
                        <p className='questionPage-feedback-pioche'>
                            Piochez la carte <span>{currentQuestion.takeCardNumber}</span>
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
}
